import React, { useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getPortfolioUpdateKpis } from 'gqlQueries/priceSimulator';
import { portfolioUpdateKpiParser } from 'parser/priceSimulator/priceSimulatorDataParser';
const errorMessage: string = 'Something went wrong!';

function useFetchPorfolioUpdateKpis() {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any>(null);
    const [count, setCount] = useState<number>(0);
    const offsetRef = useRef(0);

    const [fetchPortfolioUpdateKpis] = useLazyQuery(getPortfolioUpdateKpis, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
        fetchPolicy: 'network-only',
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getPortfolioUpdateKpis } = payload;
            //if data present parse it
            if (getPortfolioUpdateKpis?.portfolioUpdateJsonData?.length > 0) {
                // convert each json into object
                const rawData = getPortfolioUpdateKpis?.portfolioUpdateJsonData.map((i: any) => JSON.parse(i));
                const parsedData = portfolioUpdateKpiParser(rawData);
                setData(parsedData);
                return;
            }
            setData(null);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData(null);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchPortfolioUpdateKpis: (variables: any) => {
            offsetRef.current = variables?.variables?.offset;
            setLoading(true);
            setError(null);
            fetchPortfolioUpdateKpis(variables);
        },
    };
}

export { useFetchPorfolioUpdateKpis };
